import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Provinces from './pages/SuperAdmin/Provinces';
import CreateAdmin from './pages/SuperAdmin/CreateAdmin';
import Municipalities from './pages/ProvinceAdmin/Municipalities';
import BotConfig from './pages/MunicipalAdmin/BotConfig';
import BrandingEditor from './pages/MunicipalAdmin/BrandingEditor';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { isAuthenticated } = useAuthStore();
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    return <>{children}</>;
}

export default function App() {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }>
                    <Route index element={<Dashboard />} />
                    <Route path="provinces" element={<Provinces />} />
                    <Route path="provinces/:provinceId/municipalities" element={<Municipalities />} />
                    <Route path="municipalities/:muniId/config" element={<BotConfig />} />
                    <Route path="municipalities/:muniId/branding" element={<BrandingEditor />} />
                    <Route path="admins/create" element={<CreateAdmin />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
